<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="multi-translation" [ngClass]="{ 'web-portal': !isMfd }">
  <div>
    <!--From language-->
    <div class="fromLanguage">
      <xrx-select
        [label]="label"
        [inlineLabel]="inlineLabel"
        [list]="list"
        [localize]="localize"
        [property]="property"
        [sort]="false"
        [(selectedItem)]="selectedItem"
        (change)="onFromLanguageChange(selectedItem)"
        [required]="required"
        [error]="setting.error"></xrx-select>
    </div>
    <div class="h-divider"></div>
    <!--To language-->
    <div class="to-language">
      <xrx-multi-select
        type="group"
        [setting]="setting"
        [list]="list2"
        [label]="setting.label2"
        [placeholder]="setting.placeholder2"
        [localize]="localize"
        (change)="onToLanguageChange()"
        [required]="required"
        [leftAlignText]="true"
        [isBordered]="true"
        [hasScrollbar]="true"
        [maximumItemsSelected]="5">
      </xrx-multi-select>
    </div>
  </div>

  @if (atLeastOneError && toLanguageTouched) {
    <div>
      <span
        class="text-danger"
        [xdaTranslate]="'SDE_SELECT_MIN1_OUTPUT'"></span>
    </div>
  }
  @if (sameLanguageError) {
    <div>
      <span
        class="text-danger"
        [xdaTranslate]="'SDE_INPUT_LANGUAGE_OUTPUT'"></span>
    </div>
  }
  @if (!sameLanguageError && !(atLeastOneError && toLanguageTouched)) {
    <div>
      <span
        [ngClass]="{ mfd: isMfd }"
        class="info"
        [xdaTranslate]="setting.description"></span>
    </div>
  }
</div>
